import { useEffect, ReactNode } from "react";
import styles from "../../styles/Tabs.module.css";
import { calculateCarDirections } from "../../utils/calculations";
import { ErrorMessage } from "./error-message";

interface TabContentProps {
  fieldKeyFrom: string;
  fieldKeyTo: string;
  FirstLineComponent: React.ReactElement;
  ComponentUnder?: React.ReactElement;
  children: ReactNode;
  distance?: any;
  setCustomValue: any;
  distanceError: string;
  setDistanceError: (error: string) => void;
  activeTab: string;
  display2Row: boolean;
  setDisplay2Row: (flag: boolean) => void;
  useTravelTime?: boolean;
}

const TabContent: React.FC<TabContentProps> = ({
  fieldKeyFrom,
  fieldKeyTo,
  FirstLineComponent,
  ComponentUnder,
  distance,
  setCustomValue,
  children,
  distanceError,
  setDistanceError,
  activeTab,
  display2Row,
  setDisplay2Row,
  useTravelTime
}) => {
  const calculateDestination = async (from: string, to: string, destinationKey: string, setError: any) => {
    try {
      const { distance } = await calculateCarDirections(from, to);
      setCustomValue(destinationKey, distance?.value);
      setDisplay2Row(true);
    } catch (err: any) {
      if (err?.code === "ZERO_RESULTS") {
        setError(`Sorry we could not calculate your journey from ${from} to ${to}`);
      } else {
        setError("Something went wrong");
      }
      setDisplay2Row(false);
    }
  }

  useEffect(() => {
    setDistanceError('');

    if (fieldKeyFrom && fieldKeyTo) {
      if (fieldKeyFrom === fieldKeyTo) {
        setDistanceError('Please, make sure that origin and destination are different.');
        setDisplay2Row(false);
        return;
      } else {
        if (activeTab === 'FLIGHT') {
          setDisplay2Row(true);
        } else {
          calculateDestination(fieldKeyFrom, fieldKeyTo, distance, setDistanceError);
        }
      }
    } else if (!useTravelTime) {
      setDisplay2Row(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldKeyFrom, fieldKeyTo]);

  return (
    <div className={styles.tabContent}>
      <ErrorMessage message={distanceError} />

      <div className={styles.fieldRow}>
        {FirstLineComponent}
      </div>

      {!display2Row && ComponentUnder}

      {display2Row && (
        <div className={styles.tabContentAppearing}>
          {children}
        </div>
        )
      }
    </div>
  )
};

export default TabContent;
